import { lazy } from 'react';

import { Loadable } from '../../../../utils';

export const Order = Loadable(lazy(() => import('../containers/OrdersContainer')));
